export interface ErrorReportingContext {
	route?: string;
	flowStep?: string;
	component?: string;
	action?: string;
	metadata?: Record<string, unknown>;
}

const getDefaultRoute = () => {
	if (typeof window === "undefined") {
		return undefined;
	}

	return window.location.pathname;
};

const getDefaultFlowStep = () => {
	if (typeof window === "undefined") {
		return undefined;
	}

	return window.currentBuyFlowStep;
};

const normalizeError = (error: unknown): Error => {
	if (error instanceof Error) {
		return error;
	}

	if (typeof error === "string") {
		return new Error(error);
	}

	try {
		return new Error(JSON.stringify(error));
	} catch {
		return new Error("Unknown error");
	}
};

const serializeMetadata = (metadata?: Record<string, unknown>) => {
	if (!metadata) {
		return undefined;
	}

	try {
		return JSON.stringify(metadata);
	} catch {
		return "[unserializable metadata]";
	}
};

export const reportError = (
	error: unknown,
	context: ErrorReportingContext = {},
) => {
	const normalizedError = normalizeError(error);
	const payload = {
		route: context.route ?? getDefaultRoute(),
		flowStep: context.flowStep ?? getDefaultFlowStep(),
		component: context.component,
		action: context.action,
		userSafeMetadata: serializeMetadata(context.metadata),
	};

	if (typeof window !== "undefined") {
		window.newrelic?.noticeError?.(normalizedError, payload);
	}

	if (process.env.NODE_ENV === "development") {
		console.error("[reportError]", {
			message: normalizedError.message,
			name: normalizedError.name,
			...payload,
		});
	}

	return normalizedError;
};

export default reportError;